import { BrowserRouter, Routes, Route } from "react-router-dom";
import Body from "./Components/Body/body";
import ContactUs from "./Components/ContactUsComp/contactus";
import AboutUs from "./Components/AboutUsComp/aboutus";
import Membership from "./Components/MembershipComp/membership";
import Services from "./Components/ServicesComp/services";
import Footer from "./Components/FooterComp/footer";
import NewsAndEvents from "./Components/NewsandEvents/newsandevents";
import { Navbar } from "./Components/NavComp/navbar";

import SignIn from "./Components/LoginComp/signin";
import SignUp from "./Components/LoginComp/signup";
import ForgotPassword from "./Components/LoginComp/ForgotPassword";
import PrivateRoute from "./Utils/PrivateRoute"; 
import UserProfile from "./Components/UserComp/userprofile"; 
import ViewApplication from "./Components/UserComp/viewapplication"; 
import ViewPayment from "./Components/UserComp/viewpayment"; 
import AdminPanel from "./Components/AdminComp/adminpanel"; 
import ScrollToTop from "./ScrollComp/ScrollToTop"
import MemberRegistration from "./Components/MembershipComp/registration";



function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
    <Navbar />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/newsandevents" element={<NewsAndEvents /> } />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/userprofile" element={<UserProfile />} />
        <Route path="/viewapplication" element={<ViewApplication />} />
        <Route path="/viewpayment" element={<ViewPayment />} />
        <Route path="/registration" element={<MemberRegistration />} />


          <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />





      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;